import {ErrorBoundary} from "components/widgets/ErrorBoundary";
import Dropzone from "react-dropzone";
import * as AvatarEditor from "react-avatar-editor";
import {Range} from "react-range";
import * as React from "react";
import {createRef} from "react";
import {observable} from "mobx";
import {observer} from "mobx-react";


import './UserAvatarEditor.pcss';

function dataURItoBlob(dataURI) {
  const byteString = atob(dataURI.split(',')[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) { ia[i] = byteString.charCodeAt(i); }
  return new Blob([ab], { type: 'image/png' });
}

interface Props {
  setData:(data:Blob|null)=>void;
  hideTitleAndDescription?:boolean;
  existingAvatarURL:string|null;
  onClear?: () => void;
}

@observer
export class UserAvatarEditor extends React.Component<Props> {
  editor;
  dropzoneRef;
  @observable image:any|null;
  @observable avatarScale:number = 1.2;
  @observable avatarRotate:number = 0;

  constructor(props) {
    super(props);
    this.dropzoneRef = createRef();
  }

  handleDrop = (dropped) => {
    this.image = dropped[0];
  }

  handleChangeComplete = () => {
    this.props.setData(this.editor ? dataURItoBlob(this.editor.getImageScaledToCanvas().toDataURL()) : null);
  }

  setEditorRef = (editor) => {
    this.editor = editor;
  }

  render() {
    const imageState = this.image!=null;
    return (

      <div className={"userAvatarEditor"}>
        {!this.props.hideTitleAndDescription &&
          <>
            <label htmlFor={"avatar"}>Photo/Avatar</label>
            <p>Upload a photo to make interacting with others more fun!</p>
          </>
        }

        <ErrorBoundary errorMessage={"Avatar upload and modification is not behaving properly in your browser. Please report this problem to strive@well-concepts.com"}>
          {this.props.existingAvatarURL ?

            <div style={{backgroundColor:'#ccc', width:'350px'}}>
              <div style={{margin:'0px 50px 0 50px', paddingTop:'25px'}}><img style={{borderRadius:'125px'}} src={this.props.existingAvatarURL} /></div>
              <button className="iconButton" onClick={
                ()=>{
                  this.props.setData(null);
                }}><i className="fa fa-trash"></i></button>
            </div>

            :
            <div className="avatarContainer">

              <Dropzone
                name={"avatar"}
                id={'dropzone'}
                ref={this.dropzoneRef}
                onDrop={this.handleDrop}
                style={{ width: '350px', height: '350px', margin:'auto', backgroundColor:'#eee', cursor:'pointer'}}
                disabled={imageState}
              >
                {({getRootProps, getInputProps}) => {
                    return (
                      <div id={"inside"} {...getRootProps()} style={{backgroundColor:`${imageState ? 'transparent' : '#eee' }`}}>
                        <input {...getInputProps()} />
                        {imageState ?  <AvatarEditor
                            ref={this.setEditorRef}
                            image={this.image}
                            scale={this.avatarScale}
                            rotate={this.avatarRotate}
                            width={250}
                            height={250}
                            border={50}
                            color={[255, 255, 255, 0.6]} // RGBA
                            borderRadius={125}
                            onImageChange={this.handleChangeComplete}
                            onImageReady={this.handleChangeComplete}
                          />
                          :
                          <p className="uploadMessage">Click or drag a photo here.</p>}
                      </div>
                    );
                  }
                }

              </Dropzone>
            </div>
          }
        </ErrorBoundary>

        {imageState && <div className="imageEditControls">
          <div className="slider" style={{ paddingTop: '35px'}}>
            <Range
              min={1}
              max={5}
              step={.25}
              values={[this.avatarScale]}
              onChange={(v)=>{ this.avatarScale = v[0];}}
              onFinalChange={(v)=>{ this.avatarScale = v[0]; this.handleChangeComplete(); }}
              renderTrack={({ props, children }) => (
                <div
                  {...props}
                  style={{
                    ...props.style,
                    height: '6px',
                    width: '100%',
                    backgroundColor: 'rgb(235 235 235)',
                    borderRadius:'3px',
                  }}
                >
                  {children}
                </div>
              )}
              renderThumb={({ props }) => (
                <div
                  aria-label={"Zoom Slider"}
                  {...props}
                  style={{
                    ...props.style,
                    height: '30px',
                    width: '30px',
                    backgroundColor: '#FFF',
                    boxShadow:'0 1px 3px rgb(0 0 0 / 40%), 0 -1px 3px rgb(0 0 0 / 40%)',
                    borderRadius:'15px',
                  }}
                />
              )}
            />
          </div>
          <button type="button" aria-label="Rotate your avatar image clockwise" onClick={() => {
            this.avatarRotate = (this.avatarRotate+90)%360;
            this.avatarScale = this.avatarScale+.1;
            this.avatarScale = this.avatarScale-.1;
          }}><i className="fa fa-repeat"></i></button>
          <button style={{width:'200px', fontSize: '18px'}} aria-label="Clear the avatar photo so that you can start again." onClick={()=>{
            this.image = null;
            if(this.props.onClear) {
              this.props.onClear();
            }
          }}>Clear Photo</button>
        </div>
        }

      </div>

    );
  }

}
